module.exports = __webpack_public_path__ + "static/media/pandas.f589498d.png";